<template>
  <dropdown class="lng-switcher dropdown">
    <button class="btn btn-sm btn-transparent btn-contrast lng-switcher__toggle dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true" style="text-transform: uppercase;">
      {{ currentLocale }} <span class="caret"></span>
    </button>
    <template v-slot:dropdown>
      <li>
        <button class="btn-link" href="#" @click.prevent="changeLocale('ru')">
          RU
        </button>
      </li>
      <li>
        <button class="btn-link" href="#" @click.prevent="changeLocale('en')">
          EN
        </button>
      </li>
    </template>
<!--    <ul class="lng-switcher__menu dropdown-menu">-->
<!--      -->
<!--    </ul>-->
  </dropdown>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {ApplicationLocale} from '@/models/ApplicationLocale';

import {Dropdown} from 'uiv'

@Component({
  name: 'HeaderLangSwitcher',
  components: {Dropdown},
  methods: {
    changeLocale(locale: string) {
      this.$i18n.locale = locale;
      ApplicationLocale.getInstance().locale = locale;
    },
  },
  computed: {
    currentLocale(): string {
      return this.$i18n.locale;
    },
  },
})
export default class HeaderLangSwitcher extends Vue {
}
</script>

<style scoped lang="less">
.lng-switcher {
  ::v-deep {
    .dropdown-menu {
      margin-top: 5px;
      min-width: 67px;
      padding: 15px;
      a, .btn-link {
        text-decoration: none;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>
